<template>
  <div class="min-h-screen text-white pt-2 md:pt-8">
    <div class="container max-w-screen-lg mx-auto px-4 py-8 h-full">
      <div class="flex items-center gap-4 mb-6">
        <BackToLoginButton v-if="isStandalone" />
        <h1 class="text-2xl md:text-5xl font-bold md:text-center">
          Assessment Overview
        </h1>
      </div>
      <div class="flex flex-col gap-4 pt-4 md:pt-8">
        <p class="mb-2">
          It is critical for each user to create a performance baseline to
          measure improvement throughout the training program. This is
          accomplished through completing an initial assessment before starting
          the training and taking periodic assessments as you continue through
          the program.
        </p>

        <p class="mb-2">
          The assessment incorporates both training games that you will see in
          future sessions and tasks that are specific to the assessment. The
          assessment will take about 30 minutes to complete and can be completed
          all at one time or it can be completed at your own pace (your progress
          will be saved after the completion of each assessment task). Remember
          though that all assessment components need to be completed prior to
          starting your first training session.
        </p>

        <p class="mb-2">
          You will take your initial assessment right after enrolling, and then
          you will reassess after the completion of each set of 24 sessions.
        </p>

        <h2 class="text-2xl md:text-3xl font-bold text-center md:text-left">
          Following are the assessment components:
        </h2>

        <ul class="md:space-y-3 list-decimal pl-4">
          <li>Reaction - assessment of basic reaction time</li>
          <li>Focus - assessment of sustained focus and attention</li>
          <li>
            Visual - assessment of reaction time while managing distractor cues
          </li>
          <li>
            Tracking - assessment of processing multiple objects simultaneously
          </li>
          <li>Inhibition - assessment of reaction time and inhibition</li>
          <li>Memory - assessment of working memory</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import BackToLoginButton from "@/components/general/BackToLoginButton.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const isStandalone = computed(() => {
  return route.meta.isStandalone;
});
</script>
